(function() {
  /*
   * ARTMERE locale rule, 2026-10-15. One rule for every switcher: header lists,
   * footer EN/DE toggle and footer country select. It matches layout/theme.liquid.
   * German pages belong to a German-speaking market (DE, AT, CH); every other
   * market uses English. Switching the language keeps the visitor's market when
   * it fits, otherwise Germany (German) or the United States (English).
   * Switching the country picks the matching language. Browser language is never used.
   */
  var GERMAN_MARKETS = ['DE', 'AT', 'CH'];

  function isGermanMarket(country) {
    return GERMAN_MARKETS.indexOf(country) !== -1;
  }

  function countryForLocale(locale, currentCountry) {
    if (locale === 'de') return isGermanMarket(currentCountry) ? currentCountry : 'DE';
    return currentCountry && currentCountry !== 'DE' ? currentCountry : 'US';
  }

  function localeForCountry(country, currentLocale) {
    if (country === 'DE') return 'de';
    if (isGermanMarket(country)) return currentLocale === 'de' ? 'de' : 'en';
    return 'en';
  }

  function isGermanPath(path) {
    return /^\/de(\/|$)/.test(path || '');
  }

  function getCurrentLocale() {
    return isGermanPath(window.location.pathname) ? 'de' : 'en';
  }

  function getCurrentCountry() {
    if (window.Shopify && Shopify.country) return Shopify.country;
    var countryInput = document.querySelector('.localization-form input[name="country_code"]');
    if (countryInput && countryInput.value) return countryInput.value;
    var countrySelect = document.querySelector('select[name="country_code"]');
    return countrySelect && countrySelect.value ? countrySelect.value : '';
  }

  function navigateTo(locale, country) {
    var url = new URL(window.location.href);
    var path = url.pathname || '/';
    if (locale === 'de' && !isGermanPath(path)) {
      path = '/de' + (path === '/' ? '/' : path);
    } else if (locale === 'en') {
      path = path.replace(/^\/de(?=\/|$)/, '') || '/';
    }
    url.pathname = path;
    url.searchParams.set('country', country);
    window.location.assign(url.pathname + url.search + url.hash);
  }

  function submitSyncedLocalization(form, locale, country) {
    var localeInput = form.querySelector('input[name="locale_code"]');
    var countryInput = form.querySelector('input[name="country_code"]');
    var returnToInput = form.querySelector('input[name="return_to"]');
    if (!localeInput || !countryInput) return false;

    localeInput.value = locale;
    countryInput.value = country;
    if (returnToInput) returnToInput.value = window.location.pathname + window.location.search;
    form.submit();
    return true;
  }

  document.addEventListener('click', function(e) {
    var directLocaleLink = e.target.closest('[data-artmere-locale-switch]');
    if (directLocaleLink) {
      e.preventDefault();
      var directLocale = directLocaleLink.getAttribute('data-artmere-locale-switch');
      navigateTo(directLocale, countryForLocale(directLocale, getCurrentCountry()));
      return;
    }

    var link = e.target.closest('.localization-form a[data-value]');
    if (!link) return;

    var form = link.closest('form');
    if (!form) return;

    var value = link.getAttribute('data-value') || '';
    var localeInput = form.querySelector('input[name="locale_code"]');
    var countryInput = form.querySelector('input[name="country_code"]');
    if (!localeInput || !countryInput) return;

    var isLocaleSwitch = value === value.toLowerCase();
    var isCountrySwitch = value === value.toUpperCase() && value.length === 2;

    if (isLocaleSwitch) {
      e.preventDefault();
      e.stopImmediatePropagation();
      submitSyncedLocalization(form, value, countryForLocale(value, getCurrentCountry()));
    } else if (isCountrySwitch) {
      e.preventDefault();
      e.stopImmediatePropagation();
      submitSyncedLocalization(form, localeForCountry(value, getCurrentLocale()), value);
    }
  }, true);

  // Footer country select: choose the matching language in the same step,
  // so the page loads once in the right language and currency.
  document.addEventListener('change', function(e) {
    var select = e.target;
    if (!select || select.name !== 'country_code' || !select.closest) return;
    var form = select.closest('form');
    if (!form || !/\/localization$/.test(form.getAttribute('action') || '')) return;
    var country = select.value;
    if (!country) return;
    e.stopPropagation();
    e.stopImmediatePropagation();
    navigateTo(localeForCountry(country, getCurrentLocale()), country);
  }, true);
})();
